import { render, staticRenderFns } from "./JindiaoGenericTable.vue?vue&type=template&id=57fa48a8&scoped=true&"
import script from "./JindiaoGenericTable.vue?vue&type=script&lang=js&"
export * from "./JindiaoGenericTable.vue?vue&type=script&lang=js&"
import style0 from "./JindiaoGenericTable.vue?vue&type=style&index=0&id=57fa48a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa48a8",
  null
  
)

export default component.exports